import e from"./Pagination.vue_vue&type=script&lang.js";import{render as t}from"./Pagination.vue_vue&type=template&id=5a680db4&lang.js";e.render=t;export default e;
//# sourceMappingURL=Pagination.vue.js.map
